import { useMemo } from "react";
import ITenantInMarket from "../interfaces/ITenantInMarket";
import Shape from "../interfaces/Shape";
import GeometryService from "../services/geometryService";

export default function (tenantsInMarket: ITenantInMarket[], shape: Shape | Shape[] | null): ITenantInMarket[] {
    const geometryService = useMemo(() => new GeometryService(), []);

    return useMemo(() => shape
        ? tenantsInMarket.filter(tim => {
            const centerPoint = geometryService.getShapeCenterPoint(tim.shape);
            return geometryService.isPointInsideShape({ latitude: centerPoint.lat, longitude: centerPoint.lng }, shape);
        }) : tenantsInMarket, [tenantsInMarket, shape]);
}